import { useFilter } from 'shared/common/OpenFiltersButton/hooks/useFilter'
import OpenFiltersButton from 'shared/common/OpenFiltersButton/ui'
import { disableFutureDates } from 'shared/helpers/disableFutureDates'
import { Icon } from 'shared/iconpack'
import { segmentedDateRangeOptions } from 'shared/model/commonConstants'

import OrderListFilter from 'modules/Orders/components/OrderListFilter'
import OrderTable from 'modules/Orders/components/OrderTable'
import { orderFilters } from 'modules/Orders/model/orderFilters'

import FilterRangePicker from 'shared/ui/FormQuery/FilterRangePicker'
import SearchInput from 'shared/ui/SearchInput'
import SegmentedFilter from 'shared/ui/SegmentedFilter'

import { palette } from 'shared/config/styles/palette'

const OrderList = () => {
  const { isOpen } = useFilter()

  return (
    <div className="flex-1 flex flex-col pt-[12px] gap-[12px]">
      <div className="flex gap-[12px] max-w-[1240px] px-[24px]">
        <SearchInput
          className="w-full max-w-[450px] max-h-[36px] px-[6px] py-[8px] border border-light_gray_7 rounded-[12px]"
          placeholder="Поиск по ID, номеру телефона и адресу"
        />
        <SegmentedFilter
          options={segmentedDateRangeOptions}
          className="max-w-[397px]"
        />
        <FilterRangePicker
          prefix={
            <Icon
              name="calendar"
              width={20}
              height={18}
              color={palette.dark}
            />
          }
          suffixIcon={null}
          disabledDate={disableFutureDates}
          placeholder={['Период', 'Период']}
          className="min-w-[260px] text-dark bg-light_gray_3"
        />
        <OpenFiltersButton filters={orderFilters} />
      </div>
      {isOpen && <OrderListFilter />}
      <OrderTable />
    </div>
  )
}

export default OrderList
